export default "__VITE_ASSET__DtsZgc$$__"